import { render } from "./TradeAvatarCircleBlue.vue?vue&type=template&id=8b5a02f2"
import script from "./TradeAvatarCircleBlue.vue?vue&type=script&lang=js"
export * from "./TradeAvatarCircleBlue.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__